import React from 'react';
import { Navbar } from '../components/Navbar';
import { ProductPage } from '../components/ProductPage';
import { Footer } from '../components/Footer';
export const Product = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2353" data-mp="a5q2c3g9phg8">
      <Navbar data-id="element-2354" data-mp="a712zuef2934" />
      <ProductPage data-id="element-2355" data-mp="a4f0i96dujrr" />
      <Footer data-id="element-2356" data-mp="f52n8inkweg6" />
    </div>;
};